type FormalLockNotes = {
  formal_responses_locked?: boolean;
} | null;

/**
 * True when this Formal no longer accepts in-round answers.
 * A partial hub publish sets assessment status to PUBLISHED while other
 * accounts on the same Formal are still open, so status alone is not a lock.
 * After the due date but before the due+1 job, submit is still allowed and
 * the backend stores it privately (OH1 / formal_closed_private).
 */
export const isFormalEslResponsesLocked = (
  assessment: {
    status?: string | null;
    due_date?: string | null;
    notes?: FormalLockNotes | Record<string, unknown> | null;
  },
  _accountId?: string | null
): boolean => {
  const notes = assessment.notes;
  if (!notes || typeof notes !== "object") return false;
  return Boolean(
    (notes as { formal_responses_locked?: boolean }).formal_responses_locked
  );
};
